import { useCoupon } from '@/components/js/lalaPrize/lalaCoupon';
import { mapState } from 'vuex';
import { urlHandle, gotoPage } from '../helper';

export const LINK_INTERNALS = {
  1: {
    id: 1,
    name: '下单页',
    redirectType: 'businessTab',
    businessType: 1
  },
  2: {
    id: 2,
    name: '下单页大货车tab',
    redirectType: 'businessTab',
    businessType: 3
  },
  3: {
    id: 3,
    name: '下单页搬家tab',
    redirectType: 'businessTab',
    businessType: 2
  },
  4: {
    id: 4,
    name: '下单页物流tab',
    redirectType: 'businessTab',
    businessType: 5
  },
  5: {
    id: 5,
    name: '下单页企业tab',
    redirectType: 'link',
    linkName: 'enterprise_home'
  },
  6: {
    id: 6,
    name: '会员下单页',
    redirectType: 'jsbridge',
    linkName: 'user_member_order'
  },
  7: {
    id: 7,
    name: '跳转指定车型',
    redirectType: 'toVehicleModelId'
  },
  8: {
    id: 8,
    name: '小拉下单页',
    redirectType: 'businessTab',
    businessType: 8
  },
  101: {
    id: 101,
    name: '司机认证页',
    redirectType: 'link',
    linkName: [
      {
        linkName: 'hllDriverBusiness',
        businessType: 4,
        isDefault: true
      },
      {
        linkName: 'xlDriverBusiness',
        businessType: 8
      }
    ]
  },
  102: {
    id: 102,
    name: '抢单大厅',
    redirectType: 'link',
    linkName: [
      {
        linkName: 'hllTakeOrder',
        businessType: 4,
        isDefault: true
      },
      {
        linkName: 'xlTakeOrder',
        businessType: 8
      }
    ]
  }
};

function parseLinkName(linkMap, businessType) {
  const linkObj = linkMap.find(
    item => item.businessType === Number(businessType)
  );
  if (linkObj) {
    return linkObj.linkName;
  }
  const defaultLinkObj = linkMap.find(item => item.isDefault);
  return defaultLinkObj.linkName;
}
export default {
  props: {
    linkType: String,
    href: String,
    linkId: Number
  },
  computed: {
    ...mapState('global', ['businessLine'])
  },
  methods: {
    handleRedirect() {
      if (this.linkType === 'internal') {
        const linkDescObj = LINK_INTERNALS[this.linkId];
        switch (linkDescObj.redirectType) {
          case 'businessTab':
            useCoupon(linkDescObj.businessType);
            break;
          case 'link':
            if (Array.isArray(linkDescObj.linkName)) {
              // 根据业务线选择不同跳转目标
              return gotoPage(
                parseLinkName(linkDescObj.linkName, this.businessLine)
              );
            }
            gotoPage(linkDescObj.linkName);
            break;
        }
        return;
      }
      if (this.linkType === 'custom') {
        urlHandle(this.href);
      }
    }
  }
};
